import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { useAuth } from "@clerk/react";
import { api, errMsg, mediaUrl } from "@/lib/api";

const PhotoCard = ({ kind, item, onSaved }) => {
  const { getToken } = useAuth();
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("Image must be under 5 MB");
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(`/admin/media/${kind}/${item.id}`, fd, { headers: { Authorization: `Bearer ${await getToken()}` } });
      onSaved(kind, item.id, data.image);
      toast.success("Photo updated");
    } catch (err) {
      toast.error(errMsg(err, "Upload failed"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="bg-white border border-parchment-300 rounded-2xl overflow-hidden" data-testid={`photo-card-${kind}-${item.id}`}>
      <div className="relative aspect-[4/3] bg-parchment-200 overflow-hidden grid place-items-center">
        {item.image ? <img src={mediaUrl(item.image)} alt={item.title || item.name} className="absolute inset-0 w-full h-full object-cover" /> : <span className="text-xs text-[#8A978E]">No photo yet</span>}
      </div>
      <div className="p-3">
        <p className="text-sm font-semibold text-forest-800 truncate">{item.title || item.name}</p>
        <label className="mt-2 flex items-center justify-center gap-1.5 text-xs font-semibold bg-forest-800 text-parchment rounded-full py-2 cursor-pointer hover:bg-forest-700" data-testid={`photo-upload-${kind}-${item.id}`}>
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />} {item.image ? "Replace photo" : "Upload photo"}
          <input type="file" accept="image/jpeg,image/png,image/webp" onChange={upload} disabled={busy} className="hidden" data-testid={`photo-input-${kind}-${item.id}`} />
        </label>
      </div>
    </div>
  );
};

export default function PhotoManager({ catalog, onSaved }) {
  if (!catalog) return <p className="text-[#57645A]">Loading…</p>;
  const grid = (kind, items) => (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
      {items.map((it) => <PhotoCard key={it.id} kind={kind} item={it} onSaved={onSaved} />)}
    </div>
  );
  return (
    <div className="space-y-10" data-testid="photo-manager">
      <div><p className="eyebrow mb-3">Store products</p>{grid("product", catalog.products)}</div>
      <div><p className="eyebrow mb-3">Courses</p>{grid("course", catalog.courses)}</div>
    </div>
  );
}
